import { z } from 'zod';
import { getJson, http, sendJson } from '@/shared/api/client';
import { isAppError } from '@/shared/api/errors';

export const sessionUserSchema = z.object({
  email: z.string(),
  name: z.string(),
  role: z.enum(['rm', 'analyst', 'admin']),
  /** Signed in with a temporary password from an admin: the portal asks for a new one before anything else. */
  mustChangePassword: z.boolean().default(false),
  /** The server's demo mode: the "Viewing as" switcher acts in the role picked, with all its rights. */
  demoRoles: z.boolean().default(true),
});

export type SessionUser = z.infer<typeof sessionUserSchema>;

/** Who is signed in. The session itself is an httpOnly cookie the page cannot read, so the server is asked. */
export async function fetchSession(): Promise<SessionUser | null> {
  try {
    return await getJson('/auth/me', sessionUserSchema);
  } catch (error) {
    if (isAppError(error) && error.status === 401) return null;
    throw error;
  }
}

export const signIn = (email: string, password: string) => sendJson('post', '/auth/login', sessionUserSchema, { email, password });

export const changePassword = (current: string, next: string) =>
  sendJson('post', '/auth/password', sessionUserSchema, { current, new: next });

export async function signOut(): Promise<void> {
  await http.post('/auth/logout');
}
